import React, { useEffect, useMemo, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { course_copy, course_layout_list, course_mapping_gps_update, course_rendering_option_list, course_sync_output_create, course_update, create_coursemap_rendering, details_coursemap_rendering, language_list, update_coursemap_rendering } from 'redux/CourseMapSlice';
import { course_details } from 'redux/CourseSlice';
import { country_list, state_list } from 'redux/RangeInfoSlice';
import { dateTimeFormat, decryptSecretKey, getModalProperties, normalizeUrl } from 'services/utils';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useCourseGPSMappingData, useCourseRenderingOptions, useCourseRenderingOptionsStatus } from 'hooks/CourseMapDetails';
import { applyElementChange, availableElementTypes, buildNewRenderingRow, characteristicOptionsForRow, elementOptionsForRow, findRenderingRowError, grassOptionsForRow, normalizeRenderingOptions, seasonOptionsForRow, toRenderingPayloadRow } from 'services/renderingOptions';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, FormControl, Grid, Input, MenuItem, Select } from '@mui/material';
import { CopyCourseDataTo, classification, language_listings, statusForEdit } from 'json/constants';
import useNotiStack from 'hooks/useNotistack';
import ModalWrapper from 'layout/ModalWrapper/ModalWrapper';
import Wrapper from 'layout/Wrapper/Wrapper'
import * as yup from "yup";
import CustomButton from 'ui/CustomButton/CustomButton';
import CustomInput from 'ui/CustomInput/CustomInput';
import CustomInputNoLabel from 'ui/CustomInputNoLabel/CustomInputNoLabel';
import NoificationModal from 'pages/ModalPage/NoificationModal';
import SideBarActions from 'layout/SideBarActions/SideBarActions';
import asset from 'json/assets';

import styles from "styles/pages/RangeInformation.module.scss";
import stylesModal from "styles/pages/modal.module.scss";
import stylesDrag from "styles/component/DraggableList.module.scss";
import stylesScore from "styles/pages/ScoreDetails.module.scss";
import wrapperStyles from "styles/pages/Map1.module.scss";

export default function EditCourseInfo() {
    const dispatch = useDispatch();
    const secret_Key = decryptSecretKey();
    const { toastError, toastSuccess, toastWarning } = useNotiStack();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const courseIdFromQuery = searchParams.get("courseId"); // for queryString
    const courseGPSMapping = useCourseGPSMappingData();
    const courseGPSMappingData = courseGPSMapping?.GPSList;
    let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);

    const profileDetails = JSON.parse(localStorage.getItem("profile_data"));
    const id_adminuser = localStorage.getItem("id_adminuser");
    const modalProperties = getModalProperties();

    const [courseLayout, setCourseLayout] = useState([]);
    const [loadingCountryList, setLoadingCountryList] = useState(false);
    const [countryData, setCountryData] = useState([]);
    const [loadingStateList, setLoadingStateList] = useState(false);
    const [courseDetails, setCourseDetails] = useState()
    const [stateForDrivingRange, setStateForDrivingRange] = useState();
    const [submitLoading, setSubmitLoading] = useState(false);

    const [openCopyModal, setOpenCopyModal] = useState(false);
    const [isVector, setIsVector] = useState(false);
    const [isCourseGpsSimple, setIsCourseGpsSimple] = useState(false);
    const [isScoreCard, setIsScoreCard] = useState(false)
    const [submitLoadingForCopyCourse,setSubmitLoadingForCopyCourse] = useState(false)
    const [openCancelModal, setOpenCancelModal] = useState(false)
    const [openTranslationModal, setOpenTranslationModal] = useState(false)
    const [languageList, setLanguageList] = useState();
    const [translatedCourseDetails, setTranslatedCourseDetails] = useState()
    const [selectedLangId, setSelectedLangId] = useState();
    const [submitLoadingTranslation, setSubmitLoadingTranslation] = useState(false)

    const [courseRenderingDetails, setCourseRenderingDetails] = useState([
      // { elementtype: "", grasstype: "", seasonality: "" }
    ]);
    const [courseRenderingInfo, setCourseRenderingInfo] = useState([]);
    const renderingOptionsData = useCourseRenderingOptions();
    const renderingOptionsStatus = useCourseRenderingOptionsStatus();
    const renderingOptions = useMemo(() => normalizeRenderingOptions(renderingOptionsData), [renderingOptionsData]);
    const renderingOptionsReady = renderingOptionsStatus === "loaded";
    const canAddRenderingRow = renderingOptionsReady && availableElementTypes(renderingOptions, courseRenderingDetails).length > 0;
    const [sideBarExpanded, setSideBarExpanded] = useState();
    

  const schema =  yup.object().shape(
    {
        courseName: yup
          .string()
          .trim()
          .required()
          .max(50, "Course name must be 50 characters or fewer"),
          address1: yup.string().trim().required(),
          city: yup.string().trim().required(),
          country: yup.string().required(),
          
    }
)

 const copyCourseSchema =  yup.object().shape(
  {

        idCourseLayout: yup.string().required("Select a layout"),
        courseNameForCopy: yup
        .string()
        .trim()
        .required("This field is required"),
        front9CourseId: yup.string().when("copyCourseDataTo", {
          is: "Combine Courses",
          then: (schema) => schema.trim().required("This field is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        back9CourseId: yup.string().when("copyCourseDataTo", {
          is: "Combine Courses",
          then: (schema) => schema.trim().required("This field is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
  }
)

  const translatedCourseSchema =  yup.object().shape(
    {
      translatedCourseName: yup
          .string()
          .trim()
          .required("Enter Course Name"),
          translatedAddress1: yup.string().trim().required("Enter Address"),
          translatedCity: yup.string().trim().required("Enter a City"),
    }
)

const {
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      state: undefined,
    },
  });

  const {
    handleSubmit: handleSubmitCopyCourse,
    control: controlCopyCourse,
    watch: watchCopyCourse,
    reset: resetCopyCourse,
    setValue: setValueCopyCourse,
    formState: { errors: errorsCopyCourse },
  } = useForm({
    resolver: yupResolver(copyCourseSchema),
    defaultValues:{
      copyCourseDataTo: "New Course"
    }
  });

  const {
    handleSubmit: handleSubmitTranslation,
    control: controlTranslatedCourse,
    reset: resetTranslatedCourse,
    formState: { errors: errorsTranslatedCourse, isDirty: isDirtyTranslatedDetails,dirtyFields },
  } = useForm({
    resolver: yupResolver(translatedCourseSchema),
    defaultValues:{
      translatedLanguage: 2
    }
  });


  const handleSelectMenu = (e, selectedMenu) => {
    setStateForDrivingRange(undefined);
    // setIdCountryValue(selectedMenu?.id_country);
    setLoadingStateList(true);
    setValue("state", undefined);
    dispatch(
      state_list({
        body: {
          id_adminuser: id_adminuser,
          id_country: selectedMenu?.id_country,
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        if (res?.payload?.data?.stateList?.length !== 0) {
          setStateForDrivingRange(res?.payload?.data?.stateList);
        }
        setLoadingStateList(false);
      } else {
        setLoadingStateList(false);
      }
    });
      };

      const onSubmit = (data)=>{
        const activeRenderingRows = (courseRenderingDetails || []).filter((r) => r.active === 1);
        const renderingRowError = findRenderingRowError(renderingOptions, activeRenderingRows);
        if (renderingRowError) {
          toastError(renderingRowError);
          return;
        }
        setSubmitLoading(true);

        dispatch(course_update({
        body: {
           id_courseInt: Number(courseIdFromQuery),
           courseName: data?.courseName.trim(),
           id_layoutHoles: parseInt(data?.numberOfHoles),
           address1: data?.address1.trim(),
           address2: data?.address2?.trim(),
           city: data?.city?.trim(),
           id_state: data?.state,
           otherState: data?.otherState,
           zipCode: data?.zip,
           id_country: parseInt(data?.country),
           phone: data?.phone,
           url: normalizeUrl(data?.website),
           email: data?.email,
           class: data?.classification,
          active: data.status ? parseInt(data.status): 1,
       },
   user: {
    secretKey: secret_Key,
    userName: profileDetails?.username,
  },
})
         ).then((res)=> {
  if(res?.payload?.data?.Status === 1){
    dispatch(
      course_sync_output_create({
        body: {
          id_course: Number(courseIdFromQuery),
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        }
      })
    )
      dispatch(
        course_mapping_gps_update({
          body: {
            id_course: Number(courseIdFromQuery),
            clubLat: data?.clubHouseLatitude,
            clubLon: data?.clubHouseLongitude,
            // id_courseLayout: 2,
            GPSList: temp_courseGPSMappingData,
          },
          user: {
            secretKey: secret_Key,
            userName: profileDetails?.username,
          },
        })
      ).then((res)=> {
        if(res?.payload?.data?.Status === 401){
          toastError(res?.payload?.data?.ErrorDetails[0]
          )
          setSubmitLoading(false)
        }else{
          toastSuccess(res?.payload?.data?.ErrorMessage);
          setSubmitLoading(false);
          navigate("/coursemap");
        }
        
      })
  

    // toastSuccess(res?.payload?.data?.ErrorMessage);
    // setSubmitLoading(false);
    // navigate("/coursemap");

const renderingUser = {
  secretKey: secret_Key,
  userName: profileDetails?.username,
};
const handleRenderingResponse = (res, action) => {
  const status = res?.payload?.data?.Status;
  if (status === 1) return;
  const msg = res?.payload?.data?.ErrorMessage;
  toastError(msg || `Rendering ${action} failed (Status: ${status ?? "unknown"})`);
};
const normalizeRenderingRow = (row) => toRenderingPayloadRow(renderingOptions, row);

if (courseRenderingInfo?.length === 0) {
  if (courseRenderingDetails?.length > 0) {
    const createElements = courseRenderingDetails
      .filter((r) => r.active === 1)
      .map(normalizeRenderingRow)
      .map(({ active, ...rest }) => rest);
    if (createElements.length > 0) {
      dispatch(create_coursemap_rendering({
        body: {
          id_courseInt: Number(courseIdFromQuery),
          elements: createElements,
        },
        user: renderingUser,
      })).then((res) => handleRenderingResponse(res, "create"));
    }
  }
} else {
  dispatch(update_coursemap_rendering({
    body: {
      id_courseInt: Number(courseIdFromQuery),
      elements: courseRenderingDetails.map(normalizeRenderingRow),
    },
    user: renderingUser,
  })).then((res) => handleRenderingResponse(res, "update"));
}

  }else{
    setSubmitLoading(false);
    toastError("Network Error");
  }
        })
      }

      const fetchData = async () => {
        try {
          setLoadingCountryList(true)

          const [
            layoutResponse,
            countryResponse,
            languageResponse,
            courseDetailsResponse
          ] = await Promise.all([
            dispatch(course_layout_list({
              body: {},
              user: {
                secretKey: secret_Key,
                userName: profileDetails?.username,
              },
            })).then((res)=>{
              if (res?.payload?.data?.Status === 1) {
                setCourseLayout(res?.payload?.data?.courseLayoutArray)
            } else {
                toastError("Failed to fetch course layout");
                   }
            }),
            dispatch(country_list({
              body: {},
              user: {
                secretKey: secret_Key,
                userName: profileDetails?.username,
              },
            }))?.then((res) => {
                         if (res?.payload?.data?.Status === 1) {
                           setCountryData(res?.payload?.data?.countryList);
                           setLoadingCountryList(false);
                         } else {
                          // setLoadingCountryList(false);
                          toastError("Failed to fetch countries")
                         }
                   }),


            
            dispatch(language_list({
              body: {},
              user: {
                secretKey: secret_Key,
                userName: profileDetails?.username,
              },
            })).then((res)=>{
           if(res?.payload?.data?.Status === 1){
                  setLanguageList(res?.payload?.data?.resultList)
                 }else {
                  toastError("Failed to fetch language list")
                 }
                 })
            ,
            dispatch(course_details({
              body: {
                id_courseInt: Number(courseIdFromQuery),
                stateFormat: 4,
                countryFormat: 4,
                detailLevel: 2,
              },
              user: {
                secretKey: secret_Key,
                userName: profileDetails?.username,
              },
            })).then((res)=>{
              if (res?.payload?.data?.Status === 1){
                setCourseDetails(res?.payload?.data)

                dispatch(state_list({
                  body: {
                    id_adminuser: id_adminuser,
                    id_country: res?.payload?.data?.id_country,
                  },
                  user: {
                    secretKey: secret_Key,
                    userName: profileDetails?.username,
                  },
                }))?.then((res) => {
                       if (res?.payload?.data?.Status === 1) {
                           setStateForDrivingRange(res?.payload?.data?.stateList);
                          }
                         });
              }else{
                toastError("Something went wrong.")
              }
            })
            ,
          ]);
    
       
        } catch (error) {
          // console.error("Error fetching data:", error);
          toastError("Something went wrong");
        }
      };
      // optimized
      useEffect(() => {
        fetchData();
      }, [courseIdFromQuery]);

  const id_courseLayout = courseLayout.filter((e) => e.name === courseDetails?.layoutName);

      useEffect(() => {
     reset({
      courseName: courseDetails?.courseName,
      numberOfHoles: id_courseLayout[0]?.id_layout,
      address1: courseDetails?.address1,
      address2: courseDetails?.address2,
      city: courseDetails?.city,
      state: courseDetails?.id_state,
      otherState: courseDetails?.otherState,
      zip: courseDetails?.zipCode,
      country: courseDetails?.id_country,
      phone: courseDetails?.phone,
      website: courseDetails?.url,
      email: courseDetails?.email,
      clubHouseLatitude: courseDetails?.latitude,
      clubHouseLongitude: courseDetails?.longitude,
      classification: courseDetails?.class,
      status: courseDetails?.active?.toString()
     })

      }, [courseDetails]) 

      // reset translate
      useEffect(() => {
        resetTranslatedCourse({
          translatedLanguage: selectedLangId || 2,
          // translatedCourseName: courseDetails?.courseName !== translatedCourseDetails?.courseName ? translatedCourseDetails?.courseName : "",
          translatedCourseName: translatedCourseDetails?.courseName ,
          translatedAddress1: translatedCourseDetails?.address1,
          translatedAddress2: translatedCourseDetails?.address2 ,
          translatedCity: translatedCourseDetails?.city ,
          translatedOtherState: translatedCourseDetails?.otherState ,
         
        })

      if(courseDetails && translatedCourseDetails && courseDetails?.courseName === translatedCourseDetails?.courseName){
        toastWarning("No translation available for this language, only available in English.")
        // toastWarning("Available in english only")

      }
    }, [translatedCourseDetails])
      
      
      // if(courseDetails && translatedCourseDetails && courseDetails?.courseName === translatedCourseDetails?.courseName){
      //   toastWarning("No translation avialble for this language")
      // }
          
      const handleSelectLanguage = (e, selectedLanguage)=>{
          setSelectedLangId(selectedLanguage?.id_language)
              }
   
      const handleCopyCourseDetails = () => {
        setValueCopyCourse("front9CourseId", courseIdFromQuery ? String(courseIdFromQuery) : "")
        setOpenCopyModal(true)
      }

      const handleClickVector = ()=>{
        setIsVector(!isVector);
      }
      const handleClickSimple = ()=>{
        setIsCourseGpsSimple(!isCourseGpsSimple)
      }
      const handleClickScorecard = ()=>{
        setIsScoreCard(!isScoreCard)
      }

      const copyCourseDataToValue = watchCopyCourse("copyCourseDataTo");
      const isCombineCourses = copyCourseDataToValue === "Combine Courses";
      const allCopyLayoutOptions = courseLayout?.slice(1) || [];
      const eighteenHoleLayoutOptions = allCopyLayoutOptions.filter((e) => Number(e?.holes) === 18);
      const copyCourseLayoutOptions = isCombineCourses ? eighteenHoleLayoutOptions : allCopyLayoutOptions;
      const isNineHoleCourse = Number(courseDetails?.layoutHoles) === 9;
      const copyCourseDataToOptions = isNineHoleCourse ? CopyCourseDataTo : CopyCourseDataTo.filter((e) => e?.value !== "Combine Courses");

      useEffect(() => {
        if(isCombineCourses){
          const layoutValue = watchCopyCourse("idCourseLayout");
          const isLayoutEighteenHole = eighteenHoleLayoutOptions.some((e) => String(e?.id_layout) === String(layoutValue));
          if(layoutValue && !isLayoutEighteenHole){
            setValueCopyCourse("idCourseLayout", "");
          }
        }
      }, [isCombineCourses])

      const onSubmitCopyCourseDetails = (data) =>{
        if(submitLoadingForCopyCourse){
          return;
        }
        setSubmitLoadingForCopyCourse(true)
        if(data?.copyCourseDataTo === "New Course"){
          dispatch(course_copy({
            body: {
              id_courseSource: Number(courseIdFromQuery),
              courseScorecard: isScoreCard ? 1 : 0,
              courseTees:  isScoreCard ? 1 : 0,
              courseGPS: isCourseGpsSimple ? 1 : 0,
              courseGPSVector: isVector ? 1 : 0,
              id_courseLayout: data?.idCourseLayout,
              courseDetails: 1,
              courseName: data?.courseNameForCopy
            },
            user: {
              secretKey: secret_Key,
              userName: profileDetails?.username,
            }
          })).then((res) => {
            if(res?.payload?.data?.Status === 1){
              toastSuccess("Action Successful")
              setSubmitLoadingForCopyCourse(false)
              setOpenCopyModal(false);
              resetCopyCourse();
              setIsVector(false);
              setIsCourseGpsSimple(false);
              setIsScoreCard(false);
              navigate(`/editCourseInformation/course?courseId=${res?.payload?.data?.id_course}`)
            }else{
              setSubmitLoadingForCopyCourse(false)
            }
          })


        }
        else if(data?.copyCourseDataTo === "Combine Courses"){
          const isLayoutEighteenHole = eighteenHoleLayoutOptions.some((e) => String(e?.id_layout) === String(data?.idCourseLayout));
          if(!isLayoutEighteenHole){
            setSubmitLoadingForCopyCourse(false)
            toastError("Select an 18-hole course layout")
            return;
          }
          dispatch(course_copy({
            body: {
              id_courseFront9: Number(data?.front9CourseId),
              id_courseBack9: Number(data?.back9CourseId),
              useCourseDetails: "Front9",
              courseScorecard: 0,
              courseTees: 0,
              courseGPS: isCourseGpsSimple ? 1 : 0,
              courseGPSVector: isVector ? 1 : 0,
              id_courseLayout: data?.idCourseLayout,
              courseDetails: 1,
              courseName: data?.courseNameForCopy
            },
            user: {
              secretKey: secret_Key,
              userName: profileDetails?.username,
            }
          })).then((res) => {
            if(res?.payload?.data?.Status === 1){
              toastSuccess("Action Successful")
              setSubmitLoadingForCopyCourse(false)
              setOpenCopyModal(false);
              resetCopyCourse();
              setIsVector(false);
              setIsCourseGpsSimple(false);
              setIsScoreCard(false);
              navigate(`/editCourseInformation/course?courseId=${res?.payload?.data?.id_course}`)
            }else{
              setSubmitLoadingForCopyCourse(false)
              const errorDetails = res?.payload?.data?.ErrorDetails;
              const errorDetailsMessage = Array.isArray(errorDetails) ? errorDetails.join(" ") : "";
              toastError(errorDetailsMessage || res?.payload?.data?.ErrorMessage || "Something went wrong")
            }
          })
        }
        else{
          dispatch(course_copy({
            body: {
              id_courseSource: Number(courseIdFromQuery),
              courseScorecard: isScoreCard ? 1 : 0,
              courseTees:  isScoreCard ? 1 : 0,
              courseGPS: isCourseGpsSimple ? 1 : 0,
              courseGPSVector: isVector ? 1 : 0,
              id_courseLayout: data?.idCourseLayout,
              courseDetails: 1,
              id_course: watchCopyCourse("copyCourseDataTo") === "Existing Course" && Number(data?.courseNameForCopy)
            },
            user: {
              secretKey: secret_Key,
              userName: profileDetails?.username,
            }
          })).then((res)=>{
           if(res?.payload?.data?.Status === 1) {
            setSubmitLoadingForCopyCourse(false)
            setOpenCopyModal(false);
            resetCopyCourse();
            setIsVector(false);
            setIsCourseGpsSimple(false);
            setIsScoreCard(false);
            navigate(`/editCourseInformation/course?courseId=${res?.payload?.data?.id_course}`)
           }else{
            setSubmitLoadingForCopyCourse(false)
            if(res?.payload?.data?.Status === 501 && res?.payload?.data?.ErrorDetails?.propertyName === "id"){
              toastError(`CourseId ${res?.payload?.data?.ErrorDetails?.value} is not found.`)
            }else{
              toastError("Something went wrong")
            }
           }    
          })
        }
         
              }

              const handleClickCancel = () =>{
                if(isDirty){
                  setOpenCancelModal(true)
                }else{
                  navigate("/coursemap")
                }
              }

            useEffect(() => {
              if(openTranslationModal){
                dispatch(course_details({
                  body: {
                id_courseInt: Number(courseIdFromQuery),
                stateFormat: 4,
                countryFormat: 4,
                detailLevel: 2,
                id_language: selectedLangId || 2
              },
              user: {
                secretKey: secret_Key,
                userName: profileDetails?.username,
              },
            })).then((res)=> {
              if(res?.payload?.data?.Status === 1){
                setTranslatedCourseDetails(res?.payload?.data)
              }
            })
              }
        
              
            }, [openTranslationModal,selectedLangId])
              
          const onSubmitTranslation = (data)=> {
               if(isDirtyTranslatedDetails){
           // if(dirtyFields.translatedAddress1 || dirtyFields.translatedCourseName){
                       setSubmitLoadingTranslation(true)
                       dispatch(course_update({
                   body: {
                     id_courseInt: Number(courseIdFromQuery),
                     courseName: data?.translatedCourseName.trim(),
                     address1: data?.translatedAddress1.trim(),
                     address2: data?.translatedAddress2?.trim(),
                     city: data?.translatedCity?.trim(),
                     otherState: data?.translatedOtherState,
                     id_language: data?.translatedLanguage
                   },
                   user: {
                     secretKey: secret_Key,
                     userName: profileDetails?.username,
                   }
                   })
                   ).then((res)=>{
                   if(res?.payload?.data?.Status === 1){
                     toastSuccess(res?.payload?.data?.ErrorMessage)
                     setSubmitLoadingTranslation(false)
                     setOpenTranslationModal(false)
                   }
                   })
                    }else{
                        toastWarning("No changes made!")
                    }
          }

          const  handleRedirectToCourseScoreCard = ()=>{
            navigate(`/scoreDetails/course?courseId=${courseIdFromQuery}`)
          }
          const handleCourseMapGps = ()=> {
            navigate(`/mapview/coursemap?course=${courseIdFromQuery}`)
          }

       


const handleAddDraggableRow = () => {
  setCourseRenderingDetails((prev) => {
    const nextRow = buildNewRenderingRow(renderingOptions, prev);
    return nextRow ? [...prev, nextRow] : prev;
  });
};

const handleSelectChangeElement = (index, event) => {
  const nextElement = event.target.value;
  setCourseRenderingDetails((rows) =>
    rows.map((row, idx) => (idx === index ? applyElementChange(renderingOptions, row, nextElement) : row))
  );
};

const handleSelectChangeCharacteristic = (index, event) => {
  const nextCharacteristic = event.target.value;
  setCourseRenderingDetails((rows) =>
    rows.map((row, idx) => (idx === index ? { ...row, characteristic: nextCharacteristic } : row)),
  );
};

const handleSelectChangeGrassType = (index, event) => {
  const updatedElements = courseRenderingDetails.map((item, idx) =>
    idx === index ? { ...item, grasstype: event.target.value } : item
  );
  setCourseRenderingDetails(updatedElements);
};

const handleSelectChangeSeason = (index, event) => {
  const updatedElements = courseRenderingDetails.map((item, idx) =>
    idx === index ? { ...item, seasonality: event.target.value } : item
  );
  setCourseRenderingDetails(updatedElements );
};

const handleDeleteRow = (index) => {
  // setCourseRenderingDetails((prevElements) => prevElements.filter((_, idx) => idx !== index));
   const updatedElements = courseRenderingDetails.map((item, idx) =>
    idx === index ? { ...item, active: 0 } : item
  );
  setCourseRenderingDetails(updatedElements);

}
useEffect(() => {
  dispatch(course_rendering_option_list({
    body: { active: 1 },
    user: {
      secretKey: secret_Key,
      userName: profileDetails?.username,
    },
  })).then((res) => {
    if (Number(res?.payload?.data?.Status) !== 1) {
      toastError(res?.payload?.data?.ErrorMessage || "Rendering options could not be loaded. The Rendering section is read-only until the page is reloaded.");
    }
  });
}, [])
useEffect(() => {
 dispatch(details_coursemap_rendering({
  body: {
    id_courseInt: Number(courseIdFromQuery),
  },
  user: {
    secretKey: secret_Key,
    userName: profileDetails?.username,
  },
 })
).then((res) => {
  if (res.payload.data.Status === 1) {
    const elements = (res.payload.data?.elements || []).map((row) => ({
      ...row,
      characteristic: row.characteristic ?? "",
    }));
    setCourseRenderingDetails(elements);
    setCourseRenderingInfo(elements);
  }
});
}, [])
const hasActiveElements = courseRenderingDetails.some(item => item.active === 1);

  return (
    <div className="main_wraper">
        <Wrapper isHeader={true} headerTitle={"COURSE MAP"}>
        <div
            className={
              sideBarExpanded
                ? `${wrapperStyles.main_wrapper_flex}`
                : `${wrapperStyles.main_wrapper_flex} ${wrapperStyles.main_wrapper_flex_open}`
            }
          >
            <div className={wrapperStyles.main_left}>
              <div className={styles.sideBar}>
                <SideBarActions 
                  form='courseInfo'
                  onCancelClick={handleClickCancel}
                  toggleSideBar={() => setSideBarExpanded(prev => !prev)} />
              </div>
            </div>
            <div className={wrapperStyles.main_rgt}>
              <div className={styles.range_sec}>
                  
                  <form className={stylesScore.editCourseInfo} id='courseInfo' key={1} onSubmit={handleSubmit(onSubmit)}
                  >
                  <Grid container spacing={0} className={styles.courseInfoForm} >
                  <Grid item md={6} xs={12} className={styles.courseInfoForm}>
                  <div className={styles.range_sec_box}>
                    <div className={styles.range_head}>
                    <p>Edit{ ` #${courseIdFromQuery} - ${(courseDetails?.courseName) || "--"}`}</p>
                    <button
                              type="button"
                              onClick={() => setOpenTranslationModal(true)}
                            >
                              <img src={asset.translateIcon} alt="img" />
                            </button>
                    </div>

                    <div className={`${styles.range_form} ${styles.range_form_cmn}`}>
                            <div className={styles.formSec}>
                              <Grid container spacing={0} sx={{ whiteSpace: 'nowrap' }}>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} md={4}>
                                        <label>Course Name*</label>
                                      </Grid>
                                      <Grid item xs={7} md={7}>
                                        {errors?.courseName?.message  && (
                                          <p className={styles.errorMsg}>
                                            {errors.courseName.message}
                                          </p>
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Controller
                                      control={control}
                                      name="courseName"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInputNoLabel
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          // disabled={submitLoading}
                                          // label="Range Name *"
                                          // error={Boolean(errors?.rangeName)}
                                          // helperText={errors?.rangeName?.message}
                                        />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>Number of holes*</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                        {errors?.numberOfHoles?.message  && (
                                          <p className={styles.requiredContent}>
                                            {errors.numberOfHoles.message}
                                          </p>
                                        )}
                                      </Grid>
                                    </Grid>
                                    
                                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                                      <Controller
                                        control={control}
                                        name="numberOfHoles"
                                        
                                        render={({ field: { onChange, value } }) => (
                                          <Select 
                                            displayEmpty
                                            defaultValue=""
                                            id="demo-simple-select"
                                            onChange={onChange}
                                            // value={value}
                                            value={value ? value : ""}
                                          >
                                            <MenuItem value="" disabled>
                                              Select Layout
                                            </MenuItem>
                                            {courseLayout?.slice(1).map((e) => {
                                              return (
                                                <MenuItem
                                                  key={e?.id_layout}
                                                  value={e?.id_layout}
                                                >
                                                  {e?.name}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        )}
                                      />
                                    </FormControl>
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={5} md={5}>
                                        <label>ADDRESS 1*</label>
                                      </Grid>
                                      <Grid item xs={7} md={7}>
                                        {errors.address1 && (
                                          <p className={styles.requiredContent}>
                                            {errors.address1.message}
                                          </p>
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Controller
                                      control={control}
                                      name="address1"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInputNoLabel
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          // disabled={submitLoading}
                                          // error={Boolean(errors?.address1)}
                                          // helperText={errors?.address1?.message}
                                        />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    {/* <label>ADDRESS 2</label> */}
                                    <Controller
                                      control={control}
                                      name="address2"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInput
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          label="ADDRESS 2"
                                          // disabled={submitLoading}
                                          // error={Boolean(errors?.address2)}
                                          // helperText={errors?.address2?.message}
                                        />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={5} md={5}>
                                        <label>CITY *</label>
                                      </Grid>
                                      <Grid item xs={7} md={7}>
                                        {errors.city && (
                                          <p className={styles.requiredContent}>
                                            {errors.city.message}
                                          </p>
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Controller
                                      control={control}
                                      name="city"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInputNoLabel
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          label="CITY *"
                                          // disabled={submitLoading}
                                          // error={Boolean(errors?.city)}
                                          // helperText={errors?.city?.message}
                                        />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <label>STATE</label>
                                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                                      {/* {loadingStateList && (
                                        <BackdropLoader open={true} />
                                      )} */}

                                      {stateForDrivingRange &&
                                      stateForDrivingRange !== undefined &&
                                      stateForDrivingRange?.length !== 0 ? (
                                        <Controller
                                          control={control}
                                          name="state"
                                          // {...register("country")}
                                          render={({
                                            field: { onChange, value },
                                          }) => (
                                            <Select
                                              id="demo-simple-select"
                                              onChange={onChange}
                                              value={value !== undefined && value}
                                            >
                                              {stateForDrivingRange &&
                                                stateForDrivingRange?.map((e) => {
                                                  return (
                                                    <MenuItem
                                                      key={e?.id_state}
                                                      value={e?.id_state}
                                                    >
                                                      {e?.stateFull}
                                                    </MenuItem>
                                                  );
                                                })}
                                            </Select>
                                          )}
                                        />
                                      ) : (
                                        <Select>
                                          <MenuItem disabled>
                                            - State not available -
                                          </MenuItem>
                                        </Select>
                                      )}
                                    </FormControl>
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    {/* <label>OTHER STATE</label> */}
                                    <Controller
                                      control={control}
                                      name="otherState"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInput
                                          label="OTHER STATE"
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          // disabled={submitLoading}
                                        />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    {/* <label>ZIP CODE</label> */}
                                    <Controller
                                      control={control}
                                      name="zip"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInput
                                          label="ZIP CODE"
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          // disabled={submitLoading}
                                        />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={5} md={5}>
                                        <label>COUNTRY *</label>
                                      </Grid>
                                      <Grid item xs={7} md={7}>
                                        {/* {errors.country && (
                                          <p className={styles.requiredContent}>
                                            {validationText.error.country}
                                          </p>
                                        )} */}
                                      </Grid>
                                    </Grid>

                                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                                      {countryData && countryData?.length !== 0 ? (
                                        <Controller
                                          control={control}
                                          name="country"
                                          // {...register("country")}
                                          render={({
                                            field: { onChange, value },
                                          }) => (
                                            <Select
                                              id="demo-simple-select"
                                              onChange={onChange}
                                              // value={value}
                                              value={value ? value : ""}
                                            >
                                              {countryData &&
                                                countryData.map((e) => {
                                                  return (
                                                    <MenuItem
                                                      value={e.id_country}
                                                      onClick={(event) =>
                                                        handleSelectMenu(event, e)
                                                      }
                                                    >
                                                      {e?.countryFull}
                                                    </MenuItem>
                                                  );
                                                })}
                                            </Select>
                                          )}
                                        />
                                      ) : (
                                        <Select>
                                          <MenuItem disabled>
                                            - Network Error -
                                          </MenuItem>
                                        </Select>
                                      )} 
                                    </FormControl>
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    {/* <label>PHONE NUMBER</label> */}
                                    <Controller
                                      control={control}
                                      name="phone"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInput
                                          label="PHONE NUMBER"
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          onKeyPress={(e) => {
                                            if (
                                              e.key === "e" ||
                                              e.key === "E" ||
                                              e.key === "-"
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onPaste={(e) => {
                                            e.preventDefault();
                                            return false;
                                          }}
                                          // disabled={submitLoading}
                                          // error={Boolean(errors?.phone)}
                                          // helperText={errors?.phone?.message}
                                        />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    {/* <label>WEBSITE</label> */}
                                    <Controller
                                      control={control}
                                      name="website"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInput
                                          label="WEBSITE"
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          // disabled={submitLoading}
                                        />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                                      <Controller
                                        control={control}
                                        name="email"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInput
                                          label="Email"
                                          placeholder=""
                                          type="text"
                                          value={value}
                                          onChange={onChange}
                                          // disabled={submitLoading}
                                        />
                                        )}
                                      />
                                      {/* {errors.status && <p className={styles.requiredContent}></p> } */}
                                    </FormControl>
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={5} md={5}>
                                        <label>ClubHouse Latitude</label>
                                      </Grid>
                                      <Grid item xs={7} md={7}>
                                        {/* {errors.latitude && (
                                          <p className={styles.requiredContent}>
                                            {validationText.error.latitude}
                                          </p>
                                        )} */}
                                      </Grid>
                                    </Grid>
                                    <Controller
                                      control={control}
                                      name="clubHouseLatitude"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInputNoLabel
                                        placeholder=""
                                        type="number"
                                        value={value}
                                        onChange={onChange}
                                        // disabled={submitLoading}
                                        onKeyPress={(e) => {
                                          if (e.key === "e" || e.key === "E") {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={5} md={5}>
                                        <label>ClubHouse Longitude</label>
                                      </Grid>
                                      <Grid item xs={7} md={7}>
                                        {/* {errors.longitude && (
                                          <p className={styles.requiredContent}>
                                            {validationText.error.longitude}
                                          </p>
                                        )} */}
                                      </Grid>
                                    </Grid>
                                    <Controller
                                      control={control}
                                      name="clubHouseLongitude"
                                      render={({ field: { onChange, value } }) => (
                                        <CustomInputNoLabel
                                        placeholder=""
                                        type="number"
                                        value={value}
                                        onChange={onChange}
                                        // disabled={submitLoading}
                                        onKeyPress={(e) => {
                                          if (e.key === "e" || e.key === "E") {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                      )}
                                    />
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                  <div className={styles.formGroup}>
                                    <label>CLASSIFICATION</label>
                                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                                      <Controller
                                        control={control}
                                        name="classification"
                                        render={({ field: { onChange, value } }) => (
                                          <Select  
                                            displayEmpty
                                            defaultValue=""
                                            id="demo-simple-select"
                                            onChange={onChange}
                                            // value={value}
                                            value={value ? value : ""}
                                          >
                                            <MenuItem value="" disabled>
                                              Select Classification
                                            </MenuItem>
                                            {classification.map((e) => {
                                              return (
                                                <MenuItem
                                                  key={e?.id}
                                                  value={e?.value}
                                                >
                                                  {e?.label}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        )}
                                      />
                                    </FormControl>
                                  </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                    <label>STATUS</label>
                                      <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                                      <Controller
                                                                        control={control}
                                                                        name="status"
                                                                        render={({ field: { onChange, value } }) => (
                                                                          <Select
                                                                            defaultValue=""
                                                                            id="demo-simple-select"
                                                                            onChange={onChange}
                                                                            value={value ? value : ""}
                                                                          >
                                                                            {statusForEdit?.map((e) => {
                                                                              return (
                                                                                <MenuItem key={e?.id} value={e?.id}>
                                                                                  {e?.value}
                                                                                </MenuItem>
                                                                              );
                                                                            })}
                                                                          </Select>
                                                                        )}
                                                                      />
                                                                    </FormControl>
                                  </div>
                                </Grid>

                              
                              </Grid>
                            </div>
                          </div>
                  </div>
                {/* submit button */}
                </Grid>

                <Grid item md={6} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                      <div className={`${styles.range_sec_box} ${styles.range_form_cmn}`}>
                        <div className={styles.range_head}>
                          <p>Mapping Status</p>
                          <button
                              type="button"
                              onClick={handleCopyCourseDetails}
                            >
                              <img src={asset.copyIcon} alt="img" />
                            </button>
                        </div>
                        <div>
                          <div className={styles.tableSec}>
                            <table>
                              <thead>

                            
                                  <tr>
                                    <th>Type</th>
                                    <th>Last Update</th>
                                    <th>Type</th>
                                    <th>Last Update</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr>
                                    <td><a style={{cursor: "pointer"}} onClick={handleRedirectToCourseScoreCard}>Scorecard</a></td>
                                    <td>{dateTimeFormat(courseDetails?.scorecardModified) || '--'}</td>
                                    <td>Sync Output</td>
                                    <td>{dateTimeFormat(courseDetails?.syncOutputModified) || '--'}</td>
                                  </tr>
                                  <tr>
                                    <td><a style={{cursor: "pointer"}} onClick={handleCourseMapGps}>Simple GPS</a></td>
                                    <td>{dateTimeFormat(courseDetails?.gpsModified) || '--'}</td>
                                    <td>Vector Output</td>
                                    <td>{dateTimeFormat(courseDetails?.vectorOutputModified) || '--'}</td>
                                  </tr>
                                  <tr>
                                  <td><a style={{cursor: "pointer"}} onClick={handleCourseMapGps}>Vector GPS</a></td>
                                  <td>{dateTimeFormat(courseDetails?.vectorModified) || '--'}</td>
                                  </tr>
                                  </tbody>
                                </table>
                        
                          </div>
                        </div>
                      </div>


                      <div className={`${stylesScore.score_sec_box} ${stylesScore.score_sec2}`}>
                        <div className={stylesScore.score_head}>
                          <p>Rendering</p>
                          <button type="button" onClick={handleAddDraggableRow} disabled={!canAddRenderingRow} title={renderingOptionsReady && !canAddRenderingRow ? "Every element type already has a row" : undefined}>
                            <svg
                              id="Group_2002"
                              data-name="Group 2002"
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                id="Ellipse_27"
                                data-name="Ellipse 27"
                                cx="10.4"
                                cy="10.4"
                                r="10.4"
                                transform="translate(1.6 1.6)"
                                fill="#fff"
                              ></circle>
                              <path
                                id="Vector"
                                d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm5.25,13H13v4.25a1,1,0,0,1-2,0V13H6.75a1,1,0,0,1,0-2H11V6.75a1,1,0,0,1,2,0V11h4.25a1,1,0,0,1,0,2Z"
                                fill="#4cb0bd"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      
                        <div className={stylesScore.dragformSec2}>
                          <div className={stylesDrag.drag_section}>
            <DragDropContext 
            // onDragEnd={handleOnDragEnd}
            >
              <Droppable droppableId="characters">
                {(provided) => (
                  <>
                    <ul className={stylesDrag.list_hdrRender}>
                    <li>ELEMENT:</li>
                    <li>GRASS TYPE:</li>
                    <li>SEASON:</li>
                    <li>CHARACTERISTIC:</li>
                      <li></li>
                    </ul>
                    <ul
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className={stylesDrag.list_body}
                    >
                    
                        
                        
                      {hasActiveElements ? 
                      <>
                      {courseRenderingDetails.map((item, index) => (
                        item.active === 1 &&
        <Draggable key={index} draggableId={`${index}`} index={index}>
          {(provided) => (
            <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            
              <div className={`${stylesDrag.formGroupRender} ${stylesDrag.cmn_lists}`}>
              <FormControl>
                  <Select
                    value={item.elementtype || ""}
                    onChange={(e) => handleSelectChangeElement(index, e)}
                    native
                    disabled={!renderingOptionsReady}
                  >
                    {elementOptionsForRow(renderingOptions, item, courseRenderingDetails).map((name) => (
                      <option key={name} value={name}>{name}</option>
                    ))}
                  </Select>
                </FormControl>
          </div>
              
          
              
              <div className={`${stylesDrag.formGroupRender} ${stylesDrag.cmn_lists}`}>
              <FormControl>
                {(() => {
                  const grassOpts = grassOptionsForRow(renderingOptions, item);
                  return (
                    <Select
                      value={grassOpts.length === 0 ? "" : (item.grasstype || "")}
                      onChange={(e) => handleSelectChangeGrassType(index, e)}
                      native
                      disabled={!renderingOptionsReady || grassOpts.length === 0}
                    >
                      <option value=""></option>
                      {grassOpts.map((name) => (
                        <option key={name} value={name}>{name}</option>
                      ))}
                    </Select>
                  );
                })()}
                </FormControl>
              </div>


              <div className={`${stylesDrag.formGroupRender} ${stylesDrag.cmn_lists}`}>
                <FormControl>
                  <Select
                    value={item.seasonality || ""}
                    onChange={(e) => handleSelectChangeSeason(index, e)}
                    native
                    disabled={!renderingOptionsReady}
                  >
                    {seasonOptionsForRow(renderingOptions, item).map((name) => (
                      <option key={name} value={name}>{name}</option>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className={`${stylesDrag.formGroupRender} ${stylesDrag.cmn_lists}`}>
                <FormControl>
                  {(() => {
                    const charOpts = characteristicOptionsForRow(renderingOptions, item);
                    return (
                      <Select
                        value={charOpts.length === 0 ? "" : (item.characteristic || "")}
                        onChange={(e) => handleSelectChangeCharacteristic(index, e)}
                        native
                        disabled={!renderingOptionsReady || charOpts.length === 0}
                      >
                        <option value=""></option>
                        {charOpts.map((name) => (
                          <option key={name} value={name}>{name}</option>
                        ))}
                      </Select>
                    );
                  })()}
                </FormControl>
              </div>
              <div className={stylesDrag.cmn_lists}>
                                  <button type="button"  
                                  onClick={() => handleDeleteRow(index)}
                                  className={stylesDrag.close_icon} tabIndex="-1">
                                    <img src={asset.close} alt="" />
                                  </button>
                                </div>
            </li>
          )}
        </Draggable>
      ))}
                      </> : <div className='notFound'><p>No Rendering Profile Available</p></div>}
                      
                            
                      {provided.placeholder}
                    </ul>
                  </>
                )}
              </Droppable>
            </DragDropContext>
      
          </div>
          </div>      
                        </div>
                    
                    </Grid>  
                    <ModalWrapper
                      open={openCancelModal}
                      onClose={()=> setOpenCancelModal(false)}
                      handleClose={()=> setOpenCancelModal(false)}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <NoificationModal
                        label="Warning"
                        backgroundColor={modalProperties.warning.backgroundColor}
                        image={modalProperties.warning.icon}
                        title="Course details are not saved"
                        content="Do you really want to exit?"
                        rejCallBack={()=> setOpenCancelModal(false)}
                        affrCallBack={()=> navigate("/coursemap")}
                      />
                    </ModalWrapper>
                  </Grid>
                  </form>
                  
              </div>
            </div>
          </div>
        </Wrapper>


        <ModalWrapper 
         noOnClose
         open={openCopyModal}
         onClose={() =>setOpenCopyModal(false)}
        //  handleClose={() =>setOpenCopyModal(false)}
        className={`${stylesModal.cmn_modal2}  cmn_modal`  }
        // className="cmn_modal"
         aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description"
         >
          <form key={2} onSubmit={handleSubmitCopyCourse(onSubmitCopyCourseDetails)}>
           <div className={stylesModal.modalMain} >
                    <div className={stylesModal.modalHeader}>
                        <h4>Copy Course { ` #${courseIdFromQuery} - ${(courseDetails?.courseName) || "--"}`}</h4>
                    </div>
                    <div className={stylesModal.modalBody}>
                        <div className={stylesModal.modal_cont}>
                           
                            <div className={stylesModal.modal_cont_right}>
                                <div className={`${styles.range_form} ${styles.range_form_cmn}`}>
                      <div className={`${styles.formSec}  ${stylesModal.formSec2} `}>
                                <Grid container spacing={2} >
                                  <Grid item xs={12} md={6} >
                                  <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                              <label>COPY DATA TO</label>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <Controller
                                  control={controlCopyCourse}
                                  name="copyCourseDataTo"
                                  render={({ field: { onChange, value } }) => (
                                    <Select   
                                      defaultValue=""
                                      id="demo-simple-select"
                                      onChange={onChange}
                                      // value={value}
                                      value={value ? value : ""}
                                     
                                    >
                                      {copyCourseDataToOptions.map((e) => {
                                        return (
                                          <MenuItem
                                            key={e?.label}
                                            value={e?.value}
                                          >
                                            {e?.label}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  )}
                                />
                              </FormControl>
                            </div>
                                  </Grid>
                                  <Grid item xs={12} md={6} >
                                  <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                              <Grid container spacing={2}>
                               <Grid item xs={5} md={5}>
                               <label>COURSE LAYOUT</label>
                               </Grid>
                               <Grid item xs={7} md={7}>
                               {errorsCopyCourse?.idCourseLayout?.message  && (
                                    <p className={styles.requiredContent}>
                                      {errorsCopyCourse.idCourseLayout.message}
                                    </p>
                                  )}
                               </Grid>
                              </Grid>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <Controller
                                  control={controlCopyCourse}
                                  name="idCourseLayout"
                                  render={({ field: { onChange, value } }) => (
                                    <Select  
                                      displayEmpty
                                      defaultValue=""
                                      id="demo-simple-select"
                                      onChange={onChange}
                                      // value={value}
                                      value={value ? value : ""}
                                     
                                    >
                                      <MenuItem value="" disabled>
                                         Select layout
                                      </MenuItem>
                                      {copyCourseLayoutOptions.map((e) => {
                                        return (
                                          <MenuItem
                                            key={e?.id_layout}
                                            value={e?.id_layout}
                                          >
                                            {e?.name}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  )}
                                />
                              </FormControl>
                            </div>
                                  </Grid>
                                 
                                  <Grid item xs={12} md={6} >
                    <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                       <Grid container spacing={2}>
                       <Grid item xs={5} md={5}>
                         <label>{copyCourseDataToValue === "Existing Course" ? "COURSE ID" : "NEW COURSE NAME"}</label>
                       </Grid>
                       <Grid item xs={7} md={7}>
                       {errorsCopyCourse?.courseNameForCopy?.message  && (
                                    <p className={styles.requiredContent}>
                                      {errorsCopyCourse.courseNameForCopy.message}
                                    </p>
                                  )}
                       </Grid>
                       </Grid>

                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                              <Controller
                                control={controlCopyCourse}
                                name="courseNameForCopy"
                                render={({ field: { onChange, value } }) => (
                                  <CustomInputNoLabel
                                    placeholder=""
                                    type={copyCourseDataToValue === "Existing Course" ? "number" : "text"}
                                    value={value}
                                    onChange={onChange}
                                    // disabled={submitLoading}
                                  />
                                )}
                              />
                              </FormControl>
                            </div>
                                  </Grid>
                                  <Grid item xs={12} md={6} >
                            <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                              <label>DATA TYPES</label>
                              <div className={`${stylesModal.radiogrp} ${isCombineCourses ? stylesModal.radiogrp_centered : ""}`}>
                                <button onClick={handleClickVector} type='button'>Vector:<span style={{ backgroundColor: isVector ? '#145BCC' : '#d8d7d8'}}></span></button>
                                <button onClick={handleClickSimple} type='button'>Simple:<span style={{ backgroundColor: isCourseGpsSimple ? '#145BCC' : '#d8d7d8'}}></span></button>
                                {!isCombineCourses && (
                                <button onClick={handleClickScorecard} type='button'>Scorecard:<span style={{ backgroundColor: isScoreCard ? '#145BCC' : '#d8d7d8'}}></span></button>
                                )}
                              </div>
                            </div>

                                  </Grid>
                                  {isCombineCourses && (
                                  <Grid item xs={12} md={6} >
                                  <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                              <Grid container spacing={2}>
                               <Grid item xs={5} md={5}>
                               <label>FRONT 9 COURSE ID</label>
                               </Grid>
                               <Grid item xs={7} md={7}>
                               {errorsCopyCourse?.front9CourseId?.message  && (
                                    <p className={styles.requiredContent}>
                                      {errorsCopyCourse.front9CourseId.message}
                                    </p>
                                  )}
                               </Grid>
                              </Grid>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                              <Controller
                                control={controlCopyCourse}
                                name="front9CourseId"
                                render={({ field: { onChange, value } }) => (
                                  <CustomInputNoLabel
                                    placeholder=""
                                    type="number"
                                    value={value}
                                    onChange={onChange}
                                  />
                                )}
                              />
                              </FormControl>
                            </div>
                                  </Grid>
                                  )}
                                  {isCombineCourses && (
                                  <Grid item xs={12} md={6} >
                                  <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                              <Grid container spacing={2}>
                               <Grid item xs={5} md={5}>
                               <label>BACK 9 COURSE ID</label>
                               </Grid>
                               <Grid item xs={7} md={7}>
                               {errorsCopyCourse?.back9CourseId?.message  && (
                                    <p className={styles.requiredContent}>
                                      {errorsCopyCourse.back9CourseId.message}
                                    </p>
                                  )}
                               </Grid>
                              </Grid>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                              <Controller
                                control={controlCopyCourse}
                                name="back9CourseId"
                                render={({ field: { onChange, value } }) => (
                                  <CustomInputNoLabel
                                    placeholder=""
                                    type="number"
                                    value={value}
                                    onChange={onChange}
                                  />
                                )}
                              />
                              </FormControl>
                            </div>
                                  </Grid>
                                  )}
                                  <Grid item xs={12} >
                                  <div className={`${styles.submitBtn_bar} ${stylesModal.submitBtn_bar} `}  >
                <div className={styles.submitBtn}>
                  <button
                    type="button"
                    className={styles.cancle_btn}
                   onClick= {() =>setOpenCopyModal(false)}
                  >
                    Cancel
                  </button>
                  
                </div>
                <div className={styles.submitBtn}>

                  <CustomButton type="submit"  disabled={submitLoadingForCopyCourse}
                  >
                    {submitLoadingForCopyCourse ? "Saving .." : "Save"}
                  </CustomButton>
                </div>
              </div>
                                  </Grid>
                                </Grid>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
            </div>
          </form>
         </ModalWrapper>

          {/* translation */}
        <ModalWrapper 
         noOnClose
         open={openTranslationModal}
         onClose={() =>setOpenTranslationModal(false)}
         className={`${stylesModal.cmn_modal2}  cmn_modal`  }
         aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description"
         >
          <form key={1} onSubmit={handleSubmitTranslation(onSubmitTranslation)}>
           <div className={stylesModal.modalMain} >
                    <div className={stylesModal.modalHeader}>
                        <h4>Course Translations</h4>
                    </div>
                    <div className={stylesModal.modalBody}>
                        <div className={stylesModal.modal_cont}>
                           
                            <div className={stylesModal.modal_cont_right}>
                                <div className={`${styles.range_form} ${styles.range_form_cmn}`}>
                      <div className={`${styles.formSec}  ${stylesModal.formSec2} `}>
                                <Grid container spacing={2} >
                                  <Grid item xs={12} md={6} >
                                  <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                              <label>Language</label>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <Controller
                                  control={controlTranslatedCourse}
                                  name="translatedLanguage"
                                  render={({ field: { onChange, value } }) => (
                                    <Select   
                                      id="demo-simple-select"
                                      onChange={onChange}
                                      // value={value}
                                      value={value ? value : ""}
                                     
                                    >
                                      {languageList?.slice(1).map((e) => {
                                        return (
                                          <MenuItem
                                          // key={e?.id_language}
                                          value={e?.id_language}
                                          onClick={(event) =>
                                            handleSelectLanguage(event, e)
                                          }
                                          >
                                            {e?.name}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  )}
                                />
                              </FormControl>
                            </div>
                                  </Grid>
                                  <Grid item xs={12} md={6} >
                                  <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                              <Grid container spacing={2}>
                               <Grid item xs={5} md={5}>
                               <label>COURSE NAME</label>
                               </Grid>
                               <Grid item xs={7} md={7}>
                               {errorsTranslatedCourse?.translatedCourseName?.message  && (
                                    <p className={styles.requiredContent}>
                                      {errorsTranslatedCourse.translatedCourseName.message}
                                    </p>
                                  )}
                               </Grid>
                              </Grid>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <Controller
                                   control={controlTranslatedCourse}
                                  name="translatedCourseName"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                    placeholder=""
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                    // disabled={submitLoading}
                                  />
                                  )}
                                />
                              </FormControl>
                            </div>
                                  </Grid>
                                 
                                  <Grid item xs={12} md={6} >
                    <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                    <Grid container spacing={2}>
                               <Grid item xs={5} md={5}>
                               <label>ADDRESS 1</label>
                               </Grid>
                               <Grid item xs={7} md={7}>
                               {errorsTranslatedCourse?.translatedAddress1?.message  && (
                                    <p className={styles.requiredContent}>
                                      {errorsTranslatedCourse.translatedAddress1.message}
                                    </p>
                                  )}
                               </Grid>
                              </Grid>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <Controller
                                  control={controlTranslatedCourse}
                                  name="translatedAddress1"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                    placeholder=""
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                    // disabled={submitLoading}
                                  />
                                  )}
                                />
                              </FormControl>
                            </div>
                                  </Grid> 
                                  <Grid item xs={12} md={6} >
                            <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                            <Grid container spacing={2}>
                               <Grid item xs={5} md={5}>
                               <label>ADDRESS 2</label>
                               </Grid>
                              </Grid>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <Controller
                                  control={controlTranslatedCourse}
                                  name="translatedAddress2"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                    placeholder=""
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                    // disabled={submitLoading}
                                  />
                                  )}
                                />
                              </FormControl>
                            </div>
                                  </Grid> 
                                  <Grid item xs={12} md={6} >
                            <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                            <Grid container spacing={2}>
                               <Grid item xs={5} md={5}>
                               <label>CITY</label>
                               </Grid>
                               <Grid item xs={7} md={7}>
                               {errorsTranslatedCourse?.translatedCity?.message  && (
                                    <p className={styles.requiredContent}>
                                      {errorsTranslatedCourse.translatedCity.message}
                                    </p>
                                  )}
                               </Grid>
                              </Grid>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <Controller
                                  control={controlTranslatedCourse}
                                  name="translatedCity"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                    placeholder=""
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                    // disabled={submitLoading}
                                  />
                                  )}
                                />
                              </FormControl>
                            </div>
                                  </Grid>
                                  <Grid item xs={12} md={6} >
                            <div className={`${styles.formGroup} ${stylesModal.formgroup2} `}>
                            <Grid container spacing={2}>
                               <Grid item xs={5} md={5}>
                               <label>OTHER STATE</label>
                               </Grid>
                               <Grid item xs={7} md={7}>
                               {/* {errorsCopyCourse?.idCourseLayout?.message  && (
                                    <p className={styles.requiredContent}>
                                      {errorsCopyCourse.idCourseLayout.message}
                                    </p>
                                  )} */}
                               </Grid>
                              </Grid>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <Controller
                                   control={controlTranslatedCourse}
                                  name="translatedOtherState"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                    placeholder=""
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                    // disabled={submitLoading}
                                  />
                                  )}
                                />
                              </FormControl>
                            </div>
                                  </Grid>
                                  <Grid item xs={12} >
                                  <div className={`${styles.submitBtn_bar} ${stylesModal.submitBtn_bar} `}  >
                <div className={styles.submitBtn}>
                  <button
                    type="button"
                    className={styles.cancle_btn}
                   onClick= {() =>setOpenTranslationModal(false)}
                  >
                    Cancel
                  </button>
                  
                </div>
                <div className={styles.submitBtn}>

                  <CustomButton type="submit"  disabled={submitLoadingTranslation}
                  >
                    
                    {submitLoadingTranslation ? "Saving .." : "Save"}
                  </CustomButton>

                 
                </div>
              </div>
                                  </Grid>
                                </Grid>
              
                                </div>
                                </div>

                               
                            </div>
                        </div>
                    </div>
                   
            </div>
          </form>
         </ModalWrapper>

    </div>
  )
}
